import { render, staticRenderFns } from "./MatchChanges.vue?vue&type=template&id=3a50549c&scoped=true&"
import script from "./MatchChanges.vue?vue&type=script&lang=js&"
export * from "./MatchChanges.vue?vue&type=script&lang=js&"
import style0 from "./MatchChanges.vue?vue&type=style&index=0&id=3a50549c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50549c",
  null
  
)

export default component.exports